module.exports = __webpack_public_path__ + "img/icon-transaction-statistics-title.svg";